const icons = {};

icons.dueDate = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="24" height="24" fill="white" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 7V19.5H19.5V7H4.5ZM4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4Z" fill="#D93562" />
</svg>


export default icons;